import { css } from '@emotion/react';

import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../../../Styles';

const SCAN_MENU_SECTION_HEADER_STYLE = css`
  label: CATEGORY_DIVIDER_STYLE;
  ${TYPOGRAPHY2.xSmallBold};
  padding: ${LAYOUT2.spacing2}px 0 ${LAYOUT2.spacingHalf}px 0;
  background-color: ${COLORS2.alwaysDark.background.dark};
  margin: 0 ${LAYOUT2.spacing2}px 0 ${LAYOUT2.spacing2}px;
  color: ${COLORS2.alwaysDark.text.darkGray};
  text-transform: uppercase;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid ${COLORS2.alwaysDark.border.darkGray};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ScanNavigatorSectionHeader = ({
  title,
  buttons,
}: {
  title: string;
  buttons?: React.ReactNode[] | React.ReactNode;
}) => {
  return (
    <div css={SCAN_MENU_SECTION_HEADER_STYLE}>
      <span>
        {title}
      </span>
      {buttons}
    </div>
  );
};
